/**
 * To guarantee Uint8Array semantics, convert nodejs Buffers
 * into vanilla Uint8Arrays
 */
export function asUint8Array(buf) {
    return buf;
}
//# sourceMappingURL=as-uint8array.js.map